module.exports = __webpack_public_path__ + "static/media/delete.c5a77a34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/delete.svg
// module id = 56
// module chunks = 0